export default {
  headers: {
    // Common headers
    result: "Резултат",
    results: "Резултати",
    current: "Тековен",
    test: "Тест",
    flagText: "Знаме",
    flags: "Знамена",
    refRange: "Реф. опсег",
    units: "Единици",
    resultTime: "Датум / Време",
    history: "Историја",
    actions: "Акции",
    visit_id: "ID на визита",
    barcode: "Баркод",
    total_results: "Резултати",
    sample_category: "Категорија",
    collection_time: "Земена",
    instrument: "Апарат",
    disk_rack: "Диск/Рафт",
    position: "Позиција",
    sample_number: "Број на примерок",
    sample_type: "Тип примерок",
    sets_count: "Сетови",
    pending_results: "Чекачки",
    approved_results: "Одобрени",
  },

  no_data: "Нема достапни податоци",
  items_per_page: "Редови по страница:",
  all: "Сите",
  clearFilters: "Исчисти филтри",
  unknown_location: "Непозната локација",

  toolbar: {
    refresh: "Освежи",
    email: "Прати по е-пошта",
    emailAction: "Е-пошта",
    pdf: "Преземи PDF",
    pdfAction: "PDF",
  },
};
